import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_INFO } from '../data/siteData';

export default function InitialConsultationCallout({
  title = "Gratis indledende samtale.",
  description = "Der tilbydes en indledende telefonisk/online samtale gratis, så du uforpligtende kan mærke efter, om kemien og rammerne passer til dig.",
  ctaText = "Book gratis samtale",
  bgImage,
  phone,
  className = ""
}) {
  const rawBgUrl = bgImage || "https://assets.auxodev.dk/assets/1d30bca3-a748-4ede-8335-828014d68a29/callout-nature-calm-bg.jpg";
  const bgImageUrl = rawBgUrl.startsWith('http') && !rawBgUrl.includes('/cdn-cgi/image/')
    ? rawBgUrl.replace('https://assets.auxodev.dk/', 'https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/')
    : rawBgUrl;
  const displayPhone = phone || SITE_INFO.phoneFormatted;
  const telLink = (phone || SITE_INFO.phone).replace(/\s+/g, '');

  return (
    <section className={`py-20 sm:py-24 relative overflow-hidden border-y border-[#2E4230] ${className}`}>
      {/* Background image & dark green calm overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={bgImageUrl}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#233424]/85 backdrop-blur-[2px]" />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white font-normal tracking-tight max-w-2xl mx-auto leading-tight">
          {title}
        </h2>

        <p className="mt-4 text-base sm:text-lg text-[#D6E2D5] max-w-2xl mx-auto leading-relaxed">
          {description}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center px-7 py-3.5 rounded-full text-base font-medium text-[#233424] bg-white hover:bg-[#F4EFE9] shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer whitespace-nowrap group hover:scale-105 active:scale-95"
          >
            <span className="whitespace-nowrap">{ctaText}</span>
            <i className="fa-solid fa-arrow-right ml-2.5 text-xs text-[#233424] transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
          </Link>

          <a
            href={`tel:${telLink}`}
            className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3.5 rounded-full text-base font-medium text-white bg-transparent hover:bg-transparent border border-white hover:border-white/80 shadow-2xs transition-all duration-200 cursor-pointer whitespace-nowrap hover:scale-105 active:scale-95"
          >
            <i className="fa-solid fa-phone text-white mr-2" aria-hidden="true" />
            <span className="whitespace-nowrap">{displayPhone}</span>
          </a>
        </div>
      </div>
    </section>
  );
}
